var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lad-experiences"},[(_vm.withContainer)?_c('el-container',[_c('el-main',[_c('LadExperiencesRandomList')],1)],1):_c('LadExperiencesRandomList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }